import classNames from 'classnames';
import { omit } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';

const propTypes = {
    name: PropTypes.string.isRequired,
    selected: PropTypes.any,
    onChange: PropTypes.func,
};

export const RadioButtonContainerPlain = ({ className = undefined, ...props }) => (
    <div className={classNames(className, 'styled-radio-inputs')} {...props} />
);

export default class RadioButtonContainer extends Component {
    getChildContext() {
        const { name, selected, onChange = () => {} } = this.props;
        return { radioButtonContainer: { name, selected, onChange } };
    }

    render() {
        const newProps = omit(this.props, ['name', 'selected', 'onChange']);
        return <RadioButtonContainerPlain {...newProps} />;
    }
}

RadioButtonContainer.propTypes = propTypes;
RadioButtonContainer.childContextTypes = {
    radioButtonContainer: PropTypes.object,
};
